type MeetingItem = {
  code?: string;
  end?: string;
  eventId: string;
  inserted?: string;
  inviteMessage?: string;
  meetingId?: number;
  participants?: any[];
  start: string;
  status: MeetingStatus | null;
  updated?: string;
};

enum MeetingStatus {
  BOOKED = 'booked',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  UNBOOKABLE = 'unbookable',
  TIME_OUT = 'timeout',
  FULL = 'full',
}

enum Sorter {
  TIME = 'time',
  NAME = 'name',
  STATUS = 'status',
}

type KeyValue = {
  [key: string]: string | number | boolean;
};

type Person = {
  companyName: string;
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  orderId: number;
  linkedIn: string;
  profileImage: string;
  telephone: string;
  questions: any[];
};

export { MeetingItem, Person, MeetingStatus, KeyValue, Sorter };
